// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import TerceraOnboardingScreenEnTemplate from '@front/templates/TerceraOnboardingScreenEnTemplate.html';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { TerceraWindowBase } from './TerceraWindowBase';
import { WDSettings } from '../settings/WDGeneralSettings';
export class TerceraOnboardingScreen extends TerceraWindowBase {
    getType() {
        return 'TerceraOnboardingScreen';
    }
    constructor() {
        super();
        this.lastindex = 1;
        this.updateSize = () => {
            const WinWidth = window.innerWidth;
            const WinHeight = window.innerHeight;
            const enoughSpaceForOnboardingH = 928;
            const enoughSpaceForOnboardingW = 1280;
            if (WinWidth <= enoughSpaceForOnboardingW || WinHeight <= enoughSpaceForOnboardingH) {
                void this.set('small', true);
            }
            if (WinWidth >= enoughSpaceForOnboardingW && WinHeight >= enoughSpaceForOnboardingH) {
                void this.set('small', false);
            }
        };
    }
    oncomplete() {
        super.oncomplete();
        window.addEventListener('resize', this.updateSize);
        this.updateSize();
        this.on('nextClick', this.nextClick);
        this.on('backClick', this.backClick);
        this.on('doneClick', this.doneClick);
        this.on('closeClick', this.close);
        this.localize();
    }
    nextClick() {
        this.SwapActiveSlide(this.lastindex + 1);
        const el = document.getElementById('slider_' + this.lastindex);
        if (el) {
            el.click();
        }
        else {
            this.lastindex--;
        }
        this.setParamOnboarding();
    }
    backClick() {
        this.SwapActiveSlide(this.lastindex - 1);
        const el = document.getElementById('slider_' + this.lastindex);
        if (el) {
            el.click();
        }
        else {
            this.lastindex++;
        }
        this.setParamOnboarding();
    }
    inputClick(index) {
        this.SwapActiveSlide(index);
        this.setParamOnboarding();
    }
    SwapActiveSlide(index) {
        const lastSlide = this.find('#slide_number_' + this.lastindex);
        const newSlide = this.find('#slide_number_' + index);
        if (lastSlide) {
            lastSlide.classList.remove('active-slide');
        }
        if (newSlide) {
            newSlide.classList.add('active-slide');
        }
        this.lastindex = index;
    }
    doneClick() {
        this.close();
    }
    dispose() {
        window.removeEventListener('resize', this.updateSize);
        WDSettings.onboardInFirstTimeShowed = true;
        SessionSettings.save();
        this.raiseOnBoardingShowed();
        super.dispose();
    }
    setParamOnboarding() {
        const maxCount = TerceraOnboardingScreen.MAX_SLIDE_COUNT_POSTFIX;
        void this.set({ counterText: this.lastindex + '/' + maxCount, showButton: this.lastindex });
        if (this.lastindex === maxCount) {
            void this.set({ closeBtnVisible: false });
        }
        else {
            void this.set({ closeBtnVisible: true });
        }
    }
    localize() {
        void this.set({
            nextButtonText: Resources.getResource('pageNavigation.nextButton'),
            backButtonText: Resources.getResource('pageNavigation.backButton'),
            doneButtonText: Resources.getResource('pageNavigation.doneButton'),
            slide1_header1: Resources.getResource('onBoarding.windowsDocking.header'),
            slide1_text1: Resources.getResource('onBoarding.windowsDocking.description'),
            slide2_header1: Resources.getResource('onBoarding.workspaceControlArea.header'),
            slide2_text1: Resources.getResource('onBoarding.workspaceControlArea.description'),
            slide2_header2: Resources.getResource('onBoarding.workspaceLock.header'),
            slide2_text2: Resources.getResource('onBoarding.workspaceLock.description'),
            slide2_header3: Resources.getResource('onBoarding.addWorkspace.header'),
            slide2_text3: Resources.getResource('onBoarding.addWorkspace.description'),
            slide3_header1: Resources.getResource('onBoarding.linkWindowsByColor.header'),
            slide3_text1: Resources.getResource('onBoarding.linkWindowsByColor.description'),
            slide4_header1: Resources.getResource('onBoarding.mouseTrading.header'),
            slide4_text1: Resources.getResource('onBoarding.mouseTrading.description1'),
            slide4_text2: Resources.getResource('onBoarding.mouseTrading.description2'),
            slide4_text3: Resources.getResource('onBoarding.mouseTrading.description3'),
            slide5_header1: Resources.getResource('onBoarding.marginRisk.header'),
            slide5_text1: Resources.getResource('onBoarding.marginRisk.description1'),
            slide5_text2: Resources.getResource('onBoarding.marginRisk.description2'),
            slide6_header1: Resources.getResource('onBoarding.delayedMarketData.header'),
            slide6_text1: Resources.getResource('onBoarding.delayedMarketData.description'),
            slide6_header2: Resources.getResource('onBoarding.instrumentInfo.header'),
            slide6_text2: Resources.getResource('onBoarding.instrumentInfo.description'),
            slide7_header1: Resources.getResource('onBoarding.accountDetailsWidget.header'),
            slide7_text1: Resources.getResource('onBoarding.accountDetailsWidget.description'),
            slide7_header2: Resources.getResource('onBoarding.help.header'),
            slide7_text2: Resources.getResource('onBoarding.help.description'),
            slide7_header3: Resources.getResource('onBoarding.generalSettings.header'),
            slide7_text3: Resources.getResource('onBoarding.generalSettings.description'),
            slide8_header1: Resources.getResource('onBoarding.style.header'),
            slide8_text1: Resources.getResource('onBoarding.style.description'),
            slide8_header2: Resources.getResource('onBoarding.displayMode.header'),
            slide8_text2: Resources.getResource('onBoarding.displayMode.description')
        });
    }
    raiseOnBoardingShowed() {
        // #110922 вызвать и затем отписаться от методов подписанных на событие срабатывающее после показа OnBoarding
        TerceraOnboardingScreen.ReleaseSubscription();
    }
    static ReleaseSubscription() {
        TerceraOnboardingScreen.OnBoardingShowed.Raise();
        const handlers = TerceraOnboardingScreen.OnShowedSubscriptionHandlers;
        for (let i = 0; i < handlers.length; i++) {
            TerceraOnboardingScreen.OnBoardingShowed.UnSubscribe(handlers[i], null);
        }
        TerceraOnboardingScreen.OnShowedSubscriptionHandlers = [];
    }
    static AddOnShownSubscribe(caller) {
        // #110922 добавляет подписку на event по окончанию показа OnBoarding
        TerceraOnboardingScreen.OnShowedSubscriptionHandlers.push(caller);
        TerceraOnboardingScreen.OnBoardingShowed.Subscribe(caller, null);
    }
    static show() {
        const screen = new TerceraOnboardingScreen();
        MainWindowManager.AddControl(screen);
    }
}
TerceraOnboardingScreen.MAX_SLIDE_COUNT_POSTFIX = 8;
TerceraOnboardingScreen.OnBoardingShowed = new CustomEvent(); // событие срабатывающее по окончанию показа OnBoarding в TerceraOnboardingScreen.prototype.dispose
TerceraOnboardingScreen.OnShowedSubscriptionHandlers = []; // функции подписанные на event по окончанию показа OnBoarding
TerceraWindowBase.extendWith(TerceraOnboardingScreen, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            movable: false,
            showHeader: false,
            showFooter: false,
            resizable: false,
            canSelect: false,
            alwaysMiddle: false,
            focused: true,
            showBorder: false,
            showModalMask: true,
            top: 0,
            left: 0,
            style_addition_body: 'onboarding-screen-addition-body',
            style_addition_jsWin: 'window-onboarding-screen',
            btnOnboardingNextStyle: 'js-button-onboarding-next',
            showButton: 1,
            counterText: '1/' + TerceraOnboardingScreen.MAX_SLIDE_COUNT_POSTFIX,
            small: false
        };
    },
    partials: {
        bodyPartial: TerceraOnboardingScreenEnTemplate
    }
});
